import { useQuery } from '@tanstack/react-query'

import { getPlantStatusAccess } from '@/api/apiService'
import { QueryKeys } from '@/core/models/enum'

// Whether the current user may view the Plant status page for the given plant
// ('' = all plants). The access rule is enforced entirely by the backend; the
// frontend only reflects the returned decision.
export function usePlantStatusAccess(plant: string, enabled: boolean) {
    return useQuery({
        queryKey: [QueryKeys.PlantStatusAccess, plant],
        queryFn: () => getPlantStatusAccess(plant),
        enabled,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    })
}
